import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MarketingReminderPopup from '../../components/betslip/MarketingReminderPopup';

import {
  dismissMarketingConsentReminder,
  setShowMarketingConsentReminder,
  updateMarketingConsent
} from '@xanadu/ui-shared/modules/user/actions';

const mapDispatchToProps = {
  dismissMarketingConsentReminder,
  setShowMarketingConsentReminder,
  updateMarketingConsent
};

function mapStateToProps() {
  return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketingReminderPopup));
